import Style from "./style"

const DefaultInput = ({ title, type, required, inputRef, defaultValue, placeholder, hint, children }) => {

    return (
        <Style.Wrapper>

            {title &&
                <Style.Title>
                    {title}
                    {required &&
                        <span>*</span>
                    }
                </Style.Title>
            }

            <Style.InputDiv>
                <Style.Input type={type} ref={inputRef} defaultValue={defaultValue} placeholder={placeholder} />
                {children}
            </Style.InputDiv>

            {hint && <p>{hint}</p>}

        </Style.Wrapper>
    )
}

export default DefaultInput